import api from '../../../../../api/client';
import { ENROLLMENT_REFUND } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getRefunds(params = {}) {
  try {
    const response = await api.get(ENROLLMENT_REFUND.INDEX, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
export async function refundAction(payload = {}) {
  try {
    const response = await api.post(ENROLLMENT_REFUND.ACTION, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function bulkRefundAction(payload = {}) {
  try {
    const response = await api.post(ENROLLMENT_REFUND.ACTION_BULK, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function exportRefundReport({
  params = {},
  fileType,
  fileName = 'Transactions_Report',
}) {
  try {
    const response = await api.get(ENROLLMENT_REFUND.EXPORT, {
      params,
      responseType: 'blob', //  token + lang injected automatically by interceptor
    });

    const config = {
      pdf: { mime: 'application/pdf', ext: '.pdf' },
      excel: {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: '.xlsx',
      },
    };

    const { mime, ext } = config[fileType] ?? {};
    if (!mime) throw new Error(`Unsupported fileType: ${fileType}`);

    // Resolve filename from Content-Disposition or fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '').trim()
      : `${fileName}_${Date.now()}${ext}`;

    if (!filename.endsWith(ext)) filename += ext;

    // Trigger browser download
    const blob = new Blob([response.data], { type: mime });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (error) {
    console.error('Export error:', error);
    return { success: false, error };
  }
}
